module.exports = __webpack_public_path__ + "img/1005.68697617.jpg";